import axios from "axios";
import { Base_URL } from "../url";

export const saveProjectDetails = async (projectData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/ProjectMaster/CreateProject?UserName=${userName}`,
      projectData,
      {
        headers: { "Content-Type": "application/json" },
      },
    );
    return response.data; // This will contain { message, projectId, projectName }
  } catch (error) {
    throw error.response?.data || "Error saving project details!";
  }
};

export const getProjectDetails = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectMaster/GetAllProjects`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching project details!";
  }
};

export const getProjectById = async (projectId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TripDetails/ProjectId?projecid=${projectId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching project by ID!";
  }
};

// NEW: Update project favourite status
// ProjectMaster.js - Ensure this function is properly exported
export const updateProjectFavourite = async (
  projectId,
  isFavourite,
  changedByUserId,
) => {
  try {
    const requestData = {
      isFavourite: isFavourite,
      changedByUserId: toString(changedByUserId),
    };

    const response = await axios.put(
      `${Base_URL}/ProjectMaster/UpdateProjectFavourite/${projectId}`,
      requestData,
      {
        headers: { "Content-Type": "application/json" },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error updating favourite status:", error);
    throw error.response?.data || "Error updating project favourite status!";
  }
};

// Project Document APIs

// Upload single document
export const uploadProjectDocument = async (formData) => {
  try {
    const response = await axios.post(
      `${Base_URL}/ProjectDocumentMaster/UploadDocument`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error uploading document!";
  }
};

// Upload multiple documents
export const uploadMultipleProjectDocuments = async (
  orgId,
  projectId,
  createdBy,
  files,
  documentTitle, // This is not being used
  documentType,
) => {
  try {
    const formData = new FormData();
    formData.append("OrgId", orgId);
    formData.append("ProjectId", projectId);
    formData.append("CreatedBy", createdBy);
    // Add document title and type
    if (documentTitle) {
      formData.append("DocumentTitle", documentTitle);
    }
    if (documentType) {
      formData.append("DocumentType", documentType);
    }

    // Append each file
    files.forEach((file) => {
      formData.append("Files", file);
    });

    const response = await axios.post(
      `${Base_URL}/ProjectDocumentMaster/UploadMultipleDocuments`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error uploading multiple documents!";
  }
};

// Create document record (without file)
export const createProjectDocument = async (documentData) => {
  try {
    const response = await axios.post(
      `${Base_URL}/ProjectDocumentMaster/CreateDocument`,
      documentData,
      {
        headers: { "Content-Type": "application/json" },
      },
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error creating document record!";
  }
};

// Get document by ID
export const getDocumentById = async (documentId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectDocumentMaster/GetDocumentById/${documentId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching document by ID!";
  }
};

// Get documents by project
export const getDocumentsByProject = async (projectId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectDocumentMaster/GetDocumentsByProject/${projectId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching documents by project!";
  }
};

// Get documents by organization
export const getDocumentsByOrg = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectDocumentMaster/GetDocumentsByOrg/${orgId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching documents by organization!";
  }
};

// Get documents by type
export const getDocumentsByType = async (documentType) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectDocumentMaster/GetDocumentsByType/${documentType}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching documents by type!";
  }
};

// Get all documents
export const getAllDocuments = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectDocumentMaster/GetAllDocuments`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching all documents!";
  }
};

// Download document
export const downloadDocument = async (documentId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectDocumentMaster/DownloadDocument/${documentId}`,
      { responseType: "blob" }, // good
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading document!";
  }
};

// Update document with file
export const updateDocumentWithFile = async (documentId, formData) => {
  try {
    const response = await axios.put(
      `${Base_URL}/ProjectDocumentMaster/UpdateDocumentWithFile/${documentId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error updating document with file!";
  }
};

// Update document (without file)
export const updateDocument = async (documentId, documentData) => {
  try {
    const response = await axios.put(
      `${Base_URL}/ProjectDocumentMaster/UpdateDocument/${documentId}`,
      documentData,
      {
        headers: { "Content-Type": "application/json" },
      },
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error updating document!";
  }
};

// Delete document with file
export const deleteDocumentWithFile = async (documentId) => {
  try {
    const response = await axios.delete(
      `${Base_URL}/ProjectDocumentMaster/DeleteDocumentWithFile/${documentId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error deleting document with file!";
  }
};

// Delete document (record only)
export const deleteDocument = async (documentId) => {
  try {
    const response = await axios.delete(
      `${Base_URL}/ProjectDocumentMaster/DeleteDocument/${documentId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error deleting document!";
  }
};

// Delete documents by project
export const deleteDocumentsByProject = async (projectId) => {
  try {
    const response = await axios.delete(
      `${Base_URL}/ProjectDocumentMaster/DeleteDocumentsByProject/${projectId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error deleting documents by project!";
  }
};

// Get project documents from Azure storage
export const getProjectDocumentsFromStorage = async (orgId, projectId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectDocumentMaster/GetProjectDocumentsFromStorage/${orgId}/${projectId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching documents from storage!";
  }
};

// Utility function to handle file download
export const handleFileDownload = async (documentId, fileName) => {
  try {
    const response = await downloadDocument(documentId);

    // Create blob link to download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { success: true, message: "File downloaded successfully" };
  } catch (error) {
    throw error.response?.data || "Error downloading file!";
  }
};

// Utility function to prepare form data for single file upload
export const prepareDocumentFormData = (documentData, file) => {
  const formData = new FormData();

  if (documentData.documentTitle)
    formData.append("DocumentTitle", documentData.documentTitle);
  if (documentData.documentType)
    formData.append("DocumentType", documentData.documentType);
  if (documentData.documentVersion)
    formData.append("DocumentVersion", documentData.documentVersion);
  if (documentData.orgId) formData.append("OrgId", documentData.orgId);
  if (documentData.projectBelong)
    formData.append("ProjectBelong", documentData.projectBelong);
  if (documentData.createdBy)
    formData.append("CreatedBy", documentData.createdBy);

  if (file) {
    formData.append("File", file);
  }

  return formData;
};

// Utility function to validate file before upload
export const validateFile = (file, maxSizeInMB = 10) => {
  const maxSize = maxSizeInMB * 1024 * 1024; // Convert to bytes
  const allowedTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "image/jpeg",
    "image/png",
    "image/gif",
    "text/plain",
    "application/zip",
    "application/x-rar-compressed",
  ];

  if (file.size > maxSize) {
    return {
      isValid: false,
      error: `File size must be less than ${maxSizeInMB}MB`,
    };
  }

  if (!allowedTypes.includes(file.type)) {
    return { isValid: false, error: "File type not supported" };
  }

  return { isValid: true, error: null };
};
